import React from 'react';
import ArticleLayout, { Labeled } from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import BlogITvsOTImage from '../images/BlogITvsOT.png';

const BlogITOTConvergence = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title={t('blogs.blogITvsOT.header1')}
      image={BlogITvsOTImage}
      imageAlt={t('blogs.blogITvsOT.header1')}
      imageFit="contain"
      author={t('blogs.blogMaimPage.Yuval')}
      date="2024-11-15"
    >
      <p>{t('blogs.blogITvsOT.IntroParagraph')}</p>

      <h2>{t('blogs.blogITvsOT.header2')}</h2>
      <ul>
        <li><Labeled text={t('blogs.blogITvsOT.feature1')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.feature2')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.feature3')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.feature4')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.feature5')} /></li>
      </ul>

      <h2>{t('blogs.blogITvsOT.header3')}</h2>
      <p>{t('blogs.blogITvsOT.benefitsIntro')}</p>
      <ol>
        <li><Labeled text={t('blogs.blogITvsOT.benefit1')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.benefit2')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.benefit3')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.benefit4')} /></li>
        <li><Labeled text={t('blogs.blogITvsOT.benefit5')} /></li>
      </ol>

      <h2>{t('blogs.blogITvsOT.header4')}</h2>
      <p>{t('blogs.blogITvsOT.conclusionParagraph')}</p>
    </ArticleLayout>
  );
};

export default BlogITOTConvergence;
